/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { DockerRunScheduledPriority } from './DockerRunScheduledPriority';
import { DockerRunScheduledPriorityFromJSON, DockerRunScheduledPriorityFromJSONTyped, DockerRunScheduledPriorityToJSON, } from './DockerRunScheduledPriority';
import type { DockerRunScheduledState } from './DockerRunScheduledState';
import { DockerRunScheduledStateFromJSON, DockerRunScheduledStateFromJSONTyped, DockerRunScheduledStateToJSON, } from './DockerRunScheduledState';
import type { DockerWorkerLabels } from './DockerWorkerLabels';
import { DockerWorkerLabelsFromJSON, DockerWorkerLabelsFromJSONTyped, DockerWorkerLabelsToJSON, } from './DockerWorkerLabels';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DockerRunScheduledUpdateRequest
 *
 */
// create custom validators for the regexes
export interface DockerRunScheduledUpdateRequest {
    /**
     *
     * #type DockerRunScheduledState
     * #memberof DockerRunScheduledUpdateRequest
        
        
         */
    state: DockerRunScheduledState;
    /**
     *
     * #type DockerRunScheduledPriority
     * #memberof DockerRunScheduledUpdateRequest
        
        
         */
    priority?: DockerRunScheduledPriority;
    /**
     *
     * #type DockerWorkerLabels
     * #memberof DockerRunScheduledUpdateRequest
        
        
         */
    runsOn?: DockerWorkerLabels;
}
/**
 * Check if a given object implements the DockerRunScheduledUpdateRequest interface.
 */
export function instanceOfDockerRunScheduledUpdateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "state" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { DockerRunScheduledPriorityValidator, DockerRunScheduledPriorityStringifyShape, DockerRunScheduledPriorityStringifyShapeProperties, } from './DockerRunScheduledPriority';
import { DockerRunScheduledStateValidator, DockerRunScheduledStateStringifyShape, DockerRunScheduledStateStringifyShapeProperties, } from './DockerRunScheduledState';
import { DockerWorkerLabelsValidator, DockerWorkerLabelsStringifyShape, DockerWorkerLabelsStringifyShapeProperties, } from './DockerWorkerLabels';
export const DockerRunScheduledUpdateRequestTypiaAssertEquals = (input: any) => {
    return ((input: any): DockerRunScheduledUpdateRequest => {
        const __is = (input: any, _exceptionable: boolean = true): input is DockerRunScheduledUpdateRequest => {
            const $join = (typia.createAssertEquals as any).join;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => ("OPEN" === input.state || "LOCKED" === input.state || "DONE" === input.state || "CANCELED" === input.state) && (undefined === input.priority || "LOW" === input.priority || "MID" === input.priority || "HIGH" === input.priority || "CRITICAL" === input.priority) && (undefined === input.runsOn || "object" === typeof input.runsOn && null !== input.runsOn && $io1(input.runsOn, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["state", "priority", "runsOn"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "string" === typeof value;
                return false;
            });
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerRunScheduledUpdateRequest => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("OPEN" === input.state || "LOCKED" === input.state || "DONE" === input.state || "CANCELED" === input.state || $guard(_exceptionable, {
                    path: _path + ".state",
                    expected: "(\"CANCELED\" | \"DONE\" | \"LOCKED\" | \"OPEN\")",
                    value: input.state
                })) && (undefined === input.priority || "LOW" === input.priority || "MID" === input.priority || "HIGH" === input.priority || "CRITICAL" === input.priority || $guard(_exceptionable, {
                    path: _path + ".priority",
                    expected: "(\"CRITICAL\" | \"HIGH\" | \"LOW\" | \"MID\" | undefined)",
                    value: input.priority
                })) && (undefined === input.runsOn || ("object" === typeof input.runsOn && null !== input.runsOn || $guard(_exceptionable, {
                    path: _path + ".runsOn",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.runsOn
                })) && $ao1(input.runsOn, _path + ".runsOn", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".runsOn",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.runsOn
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["state", "priority", "runsOn"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "string" === typeof value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "string",
                            value: value
                        });
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledUpdateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledUpdateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DockerRunScheduledUpdateRequestTypiaAssertStringify = (input: DockerRunScheduledUpdateRequest): string => {
    return ((input: any): string => { const assert = (input: any): DockerRunScheduledUpdateRequest => {
        const __is = (input: any): input is DockerRunScheduledUpdateRequest => {
            const $join = (typia.createAssertStringify as any).join;
            const $io0 = (input: any): boolean => ("OPEN" === input.state || "LOCKED" === input.state || "DONE" === input.state || "CANCELED" === input.state) && (undefined === input.priority || "LOW" === input.priority || "MID" === input.priority || "HIGH" === input.priority || "CRITICAL" === input.priority) && (undefined === input.runsOn || "object" === typeof input.runsOn && null !== input.runsOn && $io1(input.runsOn));
            const $io1 = (input: any): boolean => "number" === typeof input.length && !Number.isNaN(input.length) && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "string" === typeof value;
                return true;
            });
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerRunScheduledUpdateRequest => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $join = (typia.createAssertStringify as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("OPEN" === input.state || "LOCKED" === input.state || "DONE" === input.state || "CANCELED" === input.state || $guard(_exceptionable, {
                    path: _path + ".state",
                    expected: "(\"CANCELED\" | \"DONE\" | \"LOCKED\" | \"OPEN\")",
                    value: input.state
                })) && (undefined === input.priority || "LOW" === input.priority || "MID" === input.priority || "HIGH" === input.priority || "CRITICAL" === input.priority || $guard(_exceptionable, {
                    path: _path + ".priority",
                    expected: "(\"CRITICAL\" | \"HIGH\" | \"LOW\" | \"MID\" | undefined)",
                    value: input.priority
                })) && (undefined === input.runsOn || ("object" === typeof input.runsOn && null !== input.runsOn || $guard(_exceptionable, {
                    path: _path + ".runsOn",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.runsOn
                })) && $ao1(input.runsOn, _path + ".runsOn", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".runsOn",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.runsOn
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length && !Number.isNaN(input.length) || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "string" === typeof value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "string",
                            value: value
                        });
                    return true;
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledUpdateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledUpdateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DockerRunScheduledUpdateRequest): string => {
        const $io1 = (input: any): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
            if (["length"].some((prop: any) => key === prop))
                return true;
            const value = input[key];
            if (undefined === value)
                return true;
            if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                return "string" === typeof value;
            return true;
        });
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $join = (typia.createAssertStringify as any).join;
        const $tail = (typia.createAssertStringify as any).tail;
        const $so0 = (input: any): any => `{${undefined === input.priority ? "" : `"priority":${undefined !== input.priority ? (() => {
            if ("string" === typeof input.priority)
                return $string(input.priority);
            if ("string" === typeof input.priority)
                return "\"" + input.priority + "\"";
            $throws({
                expected: "(\"CRITICAL\" | \"HIGH\" | \"LOW\" | \"MID\" | undefined)",
                value: input.priority
            });
        })() : undefined},`}${undefined === input.runsOn ? "" : `"runsOn":${undefined !== input.runsOn ? $so1(input.runsOn) : undefined},`}"state":${(() => {
            if ("string" === typeof input.state)
                return $string(input.state);
            if ("string" === typeof input.state)
                return "\"" + input.state + "\"";
            $throws({
                expected: "(\"CANCELED\" | \"DONE\" | \"LOCKED\" | \"OPEN\")",
                value: input.state
            });
        })()}}`;
        const $so1 = (input: any): any => `{${$tail(`"length":${input.length},${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; if (["length"].some((regular: any) => regular === key))
            return ""; if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
            return `${JSON.stringify(key)}:${$string(value)}`; return ""; }).filter((str: any) => "" !== str).join(",")}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DockerRunScheduledUpdateRequestValidatorShape = {
    'state': DockerRunScheduledStateValidator.defined(),
    'priority': DockerRunScheduledPriorityValidator.optional().default(undefined),
    'runsOn': DockerWorkerLabelsValidator.optional().default(undefined),
};
export const DockerRunScheduledUpdateRequestValidator = yup.object().shape(DockerRunScheduledUpdateRequestValidatorShape);
export const DockerRunScheduledUpdateRequestStringifyShapeProperties: ObjectSchema['properties'] = {
    'state': DockerRunScheduledStateStringifyShape,
    'priority': DockerRunScheduledPriorityStringifyShape,
    'runsOn': DockerWorkerLabelsStringifyShape,
};
export const DockerRunScheduledUpdateRequestStringifyShape: ObjectSchema = {
    title: 'DockerRunScheduledUpdateRequest Stringifier',
    type: 'object',
    properties: {
        ...DockerRunScheduledUpdateRequestStringifyShapeProperties
    },
    required: [
        'state',
    ],
};
export const DockerRunScheduledUpdateRequestStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerRunScheduledUpdateRequestStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DockerRunScheduledUpdateRequestStringify: (data: DockerRunScheduledUpdateRequest) => string = DockerRunScheduledUpdateRequestStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DockerRunScheduledUpdateRequestFromJSON(json: any): DockerRunScheduledUpdateRequest {
    return DockerRunScheduledUpdateRequestFromJSONTyped(json, false);
}
export function DockerRunScheduledUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerRunScheduledUpdateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'state': DockerRunScheduledStateFromJSON(json['state']),
        'priority': !exists(json, 'priority') ? undefined : DockerRunScheduledPriorityFromJSON(json['priority']),
        'runsOn': !exists(json, 'runsOn') ? undefined : DockerWorkerLabelsFromJSON(json['runsOn']),
    };
}
export function DockerRunScheduledUpdateRequestToJSON(value?: DockerRunScheduledUpdateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'state': DockerRunScheduledStateToJSON(value.state),
        'priority': DockerRunScheduledPriorityToJSON(value.priority),
        'runsOn': DockerWorkerLabelsToJSON(value.runsOn),
    };
}
